/**
 * 省市组件
 */
import React, { useEffect, useState } from 'react';
import { Checkbox } from '@alifd/next';
import styles from './index.module.scss';

/**
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagProvince = ({
  tagItem = {}, changeData = (data) => {},
}) => {
  const [areaSelect, setAreaSelect] = useState([]);  // 选中的地区
  const [indeterminateArea, setIndeterminateArea] = useState([]); // 地区中间状态
  const [provinceSelect, setProvinceSelect] = useState([]);// 选中的省份

  useEffect(() => {
    let newAreaSelect = [...areaSelect];
    let newIndeterminateArea = [...indeterminateArea];
    let newProvinceSelect = [...provinceSelect];
    // opValue
    if(tagItem.opValue && tagItem.opValue.param_list.length!==0) { // 反显
      tagItem.opValue.param_list.forEach((areaParams,index)=>{
        let currentArea = tagItem.value.filter(areaValue=>areaValue.param_id === areaParams.param_id[0])[0]
        if(currentArea.sub_param_list.length === areaParams.sub_param_list.length) {
          newAreaSelect.push(areaParams.param_id[0]);
          currentArea.sub_param_list.forEach((provinceValue,index)=>{
            newProvinceSelect.push(`${areaParams.param_id[0]}-${provinceValue.param_id}`);
          })
        }else if(currentArea.sub_param_list.length > areaParams.sub_param_list.length) {
          newIndeterminateArea.push(areaParams.param_id[0]);
          areaParams.sub_param_list.forEach((provinceValue,index)=>{
            newProvinceSelect.push(`${areaParams.param_id[0]}-${provinceValue.param_id}`);
          })
        }
      })
      setAreaSelect(newAreaSelect);
      setIndeterminateArea(newIndeterminateArea);
      setProvinceSelect(newProvinceSelect);
    }
  }, [tagItem]);
useEffect(()=>{
  let paramsList = [];
  let newProvinceSelect = [...provinceSelect]; 
  let newTagItem = tagItem;
  newTagItem.value.forEach((areaValue,index)=>{// 遍历总的地区信息
    if( areaSelect.findIndex(areaId =>areaValue.param_id === areaId) > -1 ) { // 如果当前区域全选
      let forBDAreaValue = {...areaValue,param_id:Array.of(areaValue.param_id)}; //此处后端需要改成数组
      paramsList.push(forBDAreaValue); // 直接在参数里传入该区域全部数据
      newProvinceSelect = newProvinceSelect.filter(provinceId=> String(provinceId).split('-')[0] !== String(areaValue.param_id)) // 从选中的省份里去掉全选区域里包括的省份
    }
    newProvinceSelect.forEach((provinceId,index)=>{ // 遍历剩余的省份
      let newAreaSub = []
      if(String(provinceId).split('-')[0] === String(areaValue.param_id)) { // 如果省份的区域 等于 当前的区域
       newAreaSub.push(areaValue.sub_param_list.filter(subValue=>String(subValue.param_id) === String(provinceId).split('-')[1])[0])
       let areaIndex = paramsList.findIndex(item=>item.param_id === areaValue.param_id)
       if(areaIndex === -1) {
        let forBDAreaValue = {...areaValue,param_id:Array.of(areaValue.param_id)}; //此处后端需要改成数组
        paramsList.push({...forBDAreaValue,sub_param_list:newAreaSub});
       }else {
        paramsList[areaIndex].sub_param_list = [...paramsList[areaIndex].sub_param_list,...newAreaSub];
       }
      } 
    })
  })
  changeData({
    opValue: {
      label_id: tagItem?.id,
      param_list: paramsList,
      extra_map:{}
    },
    opType: 'ALL'
  })
},[areaSelect,provinceSelect])

  return (
    <div className={`${styles['tag-province']} tag-width`}>
      {
        tagItem.value && tagItem.value.length !== 0 &&
          tagItem.value.map((areaValue,areaIndex)=>{
            return (
              <div className={styles['big-box']}>
                <Checkbox
                  key={`${areaValue.param_id}-${areaValue.param_name}`}
                  value={areaValue.param_id}
                  checked={areaSelect.findIndex(item=>item === areaValue.param_id)>-1}
                  indeterminate={indeterminateArea.findIndex(item=>item === areaValue.param_id)>-1}
                  onChange={(v)=>{
                    let newAreaSelect = [...areaSelect];
                    let newProvinceSelect = [...provinceSelect];
                    let currentChooseIndex = newAreaSelect.findIndex(item => item === areaValue.param_id);
                    let newIndeterminateArea = [...indeterminateArea];
                    if(v) {
                      if(currentChooseIndex === -1) {// 当前选中参数数组里没有，就新插入
                        newAreaSelect.push(areaValue.param_id);
                        setAreaSelect(newAreaSelect);
                        areaValue.sub_param_list.forEach((item,index)=>{
                          newProvinceSelect.push(`${areaValue.param_id}-${item.param_id}`);
                        })
                        setProvinceSelect(newProvinceSelect);
                      }
                    }else {
                      if(currentChooseIndex > -1){ // 当前选中参数数组里有，就删除
                        newAreaSelect.splice(currentChooseIndex,1);
                        setAreaSelect(newAreaSelect);
                        setProvinceSelect(newProvinceSelect.filter(item=>String(item).split('-')[0] !== String(areaValue.param_id)));
                      }
                    }
                    setIndeterminateArea(newIndeterminateArea.filter(item=>item!==areaValue.param_id)) //将当前地区从中间状态数组中移除
                  }}
                >
                  <span className={styles['area-name']}>
                    {areaValue.param_name}
                  </span>
                </Checkbox>
                <div className={styles['sub-box']}>
                  {
                    areaValue.sub_param_list.map((provinceValue,index)=>{
                      return (
                        <Checkbox
                          key={`${provinceValue.param_id}-${provinceValue.param_name}`}
                          value={`${areaValue.param_id}-${provinceValue.param_id}`}
                          checked={provinceSelect.findIndex(item=>item === `${areaValue.param_id}-${provinceValue.param_id}`)>-1}
                          onChange={(v)=>{
                            
                            let newProvinceSelect = [...provinceSelect];
                            let currentChooseIndex = newProvinceSelect.findIndex(item => item === `${areaValue.param_id}-${provinceValue.param_id}`)
                            let newIndeterminateArea = [...indeterminateArea];
                            let newAreaSelect = [...areaSelect];
                            if(v) {
                              if(currentChooseIndex === -1) {// 当前选中参数数组里没有，就新插入
                                newProvinceSelect.push(`${areaValue.param_id}-${provinceValue.param_id}`);
                                setProvinceSelect(newProvinceSelect);
                              }
                            }else {
                              if(currentChooseIndex > -1){ // 当前选中参数数组里有，就删除
                                newProvinceSelect.splice(currentChooseIndex,1);
                                setProvinceSelect(newProvinceSelect);
                              }
                            }
                            let allSubLength = areaValue.sub_param_list.length;
                            let currentSubLength = newProvinceSelect.filter(item=>String(item).split('-')[0] === String(areaValue.param_id)).length;
                            if(allSubLength === currentSubLength) { // 如果当前地区所有省份都被选中
                              newAreaSelect.push(areaValue.param_id);
                              setAreaSelect(newAreaSelect);// 勾选当前地区
                              setIndeterminateArea(newIndeterminateArea.filter(item=>item!==areaValue.param_id)) //将当前地区从中间状态数组中移除
                            }else if(allSubLength > currentSubLength) { // 如果当前地区省份被部分选中或全部未被选中
                              setAreaSelect(newAreaSelect.filter(item=>item!==areaValue.param_id)) // 将当前地区从地区选择中移除

                              if(currentSubLength === 0) { // 如果当前地区省份未被选中
                                setIndeterminateArea(newIndeterminateArea.filter(item=>item!==areaValue.param_id)) //将当前地区从中间状态数组中移除
                              }else { // 如果当前地区省份被部分选中
                                newIndeterminateArea.push(areaValue.param_id);
                                setIndeterminateArea(newIndeterminateArea);
                              }
                            }
                          }}
                        >
                          <span className={styles['province-name']}>
                            {provinceValue.param_name}
                          </span>
                        </Checkbox>
                      )
                    })
                  }
                </div>
              </div>
            )
          })
      }
    </div>
  );
};
export default TagProvince;
